module.exports = __webpack_public_path__ + "img/strategy_pic.40d4223d.png";